export default class CodeBlock {
  constructor() {
    this.standaloneCodeBlocks = $('.code-block.standalone');
    this.regularCodeBlocks = $('.code-block');

    this.standaloneCodeBlocks
      .find('+ button > i')
      .removeClass('fa fa-clipboard small')
      .addClass('icon-copy');
    this.regularCodeBlocks
      .find('button > i')
      .removeClass('fa fa-clipboard small')
      .addClass('icon-copy');
  }

  listenEvents() {
    function listenerFunction() {
      setTimeout(
        () =>
          $(this)
            .find('i')
            .removeClass('fa fa-clipboard small')
            .addClass('icon-copy'),
        1000
      );
    }
    this.standaloneCodeBlocks.find('+ button').on('click', listenerFunction);
    this.regularCodeBlocks.find('button').on('click', listenerFunction);
  }

  stopListening() {
    this.standaloneCodeBlocks.find('+ button').off('click');
    this.regularCodeBlocks.find('button').off('click');
  }
}
